import React from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes } from './ItemTypes';
const style = {
    border: '1px dashed gray',
    backgroundColor: 'white',
    padding: '0.5em 1em',
    cursor: 'move',
    textAlign: 'center',
};
// const style = {
//     border: '1px dashed gray',
//     backgroundColor: 'white',
//     padding: '0.5rem 1rem',
//     marginRight: '1.5rem',
//     marginBottom: '1.5rem',
//     cursor: 'move',
//     float: 'left',
// };

function Box(props) {

    var name = props.name;
    var coqTermID = props.coqTermID;
    var selectPositionWithSubAction = props.selectPositionWithSubAction;

    const [{ isDragging }, drag] = useDrag({
        item: { name, type: ItemTypes.BOX },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult();
            if (item && dropResult) {
                var whereToInsert = dropResult.whereToInsert;
                var insertPosition = dropResult.insertPosition;
                selectPositionWithSubAction("dropInsert", whereToInsert, coqTermID, insertPosition)
                // alert(`You dropped ${item.name} into ${dropResult.name}  !`);
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    const opacity = isDragging ? 0.4 : 1;
    return (<div ref={drag} style={{ ...style, opacity }}>
            {name}
        </div>);

};
//


export default Box;